module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M26 0H6v32h20c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-4 21.218c0 .506-.374.782-.832.782h-8.336c-.458 0-.832-.276-.832-.782v-2.832c0-.506.38-1.396.75-1.7.774-.638 1.25-.896 3.25-1.138v-.736c-2-.632-2.082-2.21-2.082-3.562 0-2.02 1.074-3.25 2.914-3.25C18.674 8 20 9.23 20 11.25c0 1.352 0 2.93-2 3.562v.736c2 .24 2.476.5 3.25 1.138.37.304.75 1.194.75 1.7v2.832zM4 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h2V0z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/contacts-1.js
// module id = 1089
// module chunks = 14